import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const ulcers: AnswerPathTreeNode = {
  path: 'ulcers',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredUlcersDetails }],
};
